// src/components/ForgetPasswordForm.tsx
import React, { FC, useState, ChangeEvent } from 'react';
import CustomInput from './subComponents/CustomInput';
import { useNavigate } from 'react-router-dom';
import { Icons } from '@/icons';
import AuthService from '@/services/AuthService';
const { Email } = Icons;

const ForgetPasswordForm: FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState('');

  const validateEmail = (value: string) => {
    const isValid = /.+@.+\..+/.test(value);
    setEmailError(!isValid);
    setEmailErrorMessage(isValid ? '' : 'Please enter a valid email');
    return isValid;
  };

  const handleSendOtp = async () => {
    if (!validateEmail(email)) return;
    await AuthService.forgotPassword(email);
    navigate('/get-opt', { state: { email } });
  };

  return (
    <>
      <CustomInput
        id='email'
        label='Email'
        Icon={Email}
        type='email'
        placeholder='Enter email here'
        value={email}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setEmail(e.target.value);
          if (emailError) validateEmail(e.target.value);
        }}
        error={emailError}
        errorMessage={emailErrorMessage}
      />
      <button
        onClick={handleSendOtp}
        className='w-2/4 bg-[#FF0050] text-white py-2 rounded-full mt-4 hover:bg-pink-600 transition'
      >
        Get OTP
      </button>
    </>
  );
};

export default ForgetPasswordForm;
